<template>
  <div>
    <v-card-title>Want to compare anything else while you're here? We also compare...</v-card-title>
    <v-row class="mx-auto">
      <v-col
        v-for="(product, index) in productsSortedByPosition"
        :key="product.position + index"
      >
        <v-card
          elevation="1"
          class="d-flex pa-4 justify-space-between align-center"
          height="100%"
        >
          <div>
            <h3 class="primary--text">{{ product.title }}</h3>
            <p>{{ product.text }}</p>
          </div>
          <v-btn
            rounded
            color="success"
            @click.prevent="goToRelatedProduct(product.url, product.title)"
          >
            Get Quotes
          </v-btn>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { sortBy } from 'lodash';
import {
  inject,
} from '@vue/composition-api';

export default {
  name: 'lg-related-products',
  props: {
    relatedProducts: {
      type: Array,
      required: true,
    },
  },
  computed: {
    productsSortedByPosition () {
      const toSort = this.relatedProducts.slice();

      return sortBy(toSort, ['position']);
    },
  },
  methods: {
    goToRelatedProduct (url, relatedProduct) {
      this.internalTrackerResultsPage('getQuotesRelatedSystem', relatedProduct);
      window.open(url, '_blank').focus();
    },
  },
  setup () {
    const internalTrackers = inject('internalTrackers');

    return {
      ...internalTrackers,
    };
  },
};
</script>

<style scoped>
.v-card__title {
  word-break: normal;
}
</style>
